import React, { } from 'react';
import styled from 'styled-components';

import WalletConnectionProvider from 'providers/wallet/walletConnectionProvider';

import theme, {bp, color} from 'settings/theme';


type Props = {
  children?: React.ReactNode
};

// Component
const WalletLayout: React.FC<Props> = (props) => {

  return (
    <WalletConnectionProvider>
      {props.children}
    </WalletConnectionProvider>
  );
};

export default WalletLayout;



const StyledLayout = styled.div`

`;
